import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dateFormatter",
})

export class DateFormatterPipe implements PipeTransform {
  monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  transform(value: any, ...args: any[]): any {
    if (args[0] === "yyyy-mm-dd") {
      let dateFormat = value.split("-");
      return `${dateFormat[2]}/${dateFormat[1]}/${dateFormat[0]}`;
    }else if(args[0] === "dd-mm-yyyy"){
      let dateFormat = value.split("-");
      return `${dateFormat[0]}/${dateFormat[1]}/${dateFormat[2]}`;
    }
    else if(args[0] === "dd/mm/yyyy"){
      let dateFormat = value?.split(" ")?.[0]?.split('-');
      return dateFormat?`${dateFormat[0]}/${dateFormat[1]}/${dateFormat[2]}`:value;
    }
    else if(args[0] === "dd-mmm-yyyy"){
      let dateArr:any = value.split('-');
      var jsDate:any =  new Date(dateArr[1]+"/"+dateArr[0]+"/"+dateArr[2]);
      var date = jsDate.getDate()<10?'0'+jsDate.getDate():jsDate.getDate()
      return   date+ '. ' + this.monthNames[jsDate.getMonth()] + ' ' + jsDate.getFullYear();
    }
    return value;
  }
}
